export enum BackgroundJobStatus {
    Pending = 'Pending',
    InProgress = 'InProgress',
    Completed = 'Completed',
    Failed = 'Failed',
    Cancelled = 'Cancelled',
    BridgeExtractionCompleted = 'BridgeExtractionCompleted',
}

export enum BackgroundJobTaskType {
    Extract = 'Extract',
    Flow = 'Flow',
    Geocoding = 'Geocoding',
    PredictiveModelFlow = 'PredictiveModelFlow',
    Subscription = 'Subscription',
    System = 'System',
    Encryption = 'Encryption',
    Bridge = 'Bridge',
    Acceleration = 'Acceleration',
}

export enum BackgroundJobTimeRange {
    // Note:  We can't have numbers as the enum's keys so we have
    // their english name
    One = '1',
    Four = '4',
    Eight = '8',
    Twelve = '12',
    Sixteen = '16',
    Twenty = '20',
    TwentyFour = '24',
}
